<div fxLayout="row wrap" fxLayoutAlign="start center" style="margin-bottom: 0.5rem;">
    <div>
        <p-checkbox 
            (onChange)="showHidePolygons($event)"
            [(ngModel)]="showHidePoly" 
            [binary]="true" 
            [style]="{'margin-left':'0.8rem', 'margin-right':'0.5rem'}">
        </p-checkbox>
        <span style="color: #ffffff;">Visualizza/Nascondi Poligoni</span>
    </div>
</div>
<p-panel header="Dati Misurazioni">
    <div *ngIf="jsonLoaded">
        <div fxLayout="row wrap">
            <p-table 
                #dm
                [columns]="dmColumns" 
                selectionMode="single" 
                [value]="tableDataMisu" 
                [scrollable]="true"
                [(selection)]="selectedRow"
                (onRowSelect)="onTableRowSelection($event, true)" 
                (onRowUnselect)="onTableRowSelection($event, false)"
                [scrollHeight]="scrollHeight">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col *ngFor="let col of columns" [style.width]="col.width">
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-poly>
                    <tr [pSelectableRow]="poly">
                        <td>{{poly.normalized}}</td>
                        <td>{{poly.rooms}}</td>
                        <!-- <td>{{poly.macro}}</td> -->
                        <!-- <td>{{poly.tari_coeff}}</td> -->
                        <td>{{poly.area}}</td>
                        <td>{{poly.alerts}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="40">Tot. Sup. Reale: {{ totSuperficie }}mq</div>
                        <div fxFlex="25"></div>
                        <div fxFlex="40">Tot. Sup. TaRI: {{ totSuperficieTaRI }}mq</div>
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div fxLayout="row wrap" style="margin-top: 1rem;">
            <input fxFlex="99" type="text" pInputText placeholder="Filtro/Ricerca" (input)="dm.filterGlobal($event.target.value, 'contains')">
        </div>
    </div>
    <div *ngIf="!jsonLoaded" class="spinner-sm" style="margin-top: 2rem;">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</p-panel>
<p-panel header="Dizionario Rooms" [style]="{'margin-top':'0.5rem'}">
    <div *ngIf="dictLoaded">
        <div fxLayout="row wrap">
            <p-table 
                #dr 
                [columns]="drColumns" 
                [value]="tableDataDict" 
                [scrollable]="true"
                [(selection)]="selectedDict"
                selectionMode="single"
                (onRowSelect)="onDictRowSelection($event, true)" 
                (onRowUnselect)="onDictRowSelection($event, false)"
                [scrollHeight]="scrollHeight">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col *ngFor="let col of columns" [style.width]="col.width">
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dict>
                    <tr [pSelectableRow]="dict">
                        <td>{{dict.destinazioneNormalizzata}}</td>
                        <td>{{dict.destinazionePlanimetria}}</td>
                        <td>{{dict.macrogruppo}}</td>
                        <td>{{dict.coefficienteCalcoloSupTari}}</td>
                        <td style="text-align: center;">
                            <button pButton pTooltip="Assegna" tooltipPosition="left" type="button" class="editor-button-assign" (click)="onAssignDict(dict)">
                                <fa-icon [icon]="solidIcons.faShareSquare" size="1.75x"></fa-icon>
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div fxLayout="row wrap" style="margin-top: 1rem;">
            <input fxFlex="99" type="text" pInputText placeholder="Filtro/Ricerca" (input)="dr.filterGlobal($event.target.value, 'contains')">
        </div>
        <div fxLayout="row wrap" style="margin-top: 1rem;" *ngIf="!insertMode">
            <button fxFlex="99" pButton type="button" class="editor-button" (click)="onNewDict()" [disabled]="disableSave">
                Nuovo
            </button>
        </div>
        <div style="margin-top: 1rem;" *ngIf="insertMode">
            <div fxLayout="row wrap" fxLayoutAlign="start center">
                <input fxFlex="47.4" type="text" [(ngModel)]="newDict.destinazioneNormalizzata" pInputText style="margin-right: 0.5rem;" placeholder="Norm.">
                <input fxFlex="47.4" type="text" [(ngModel)]="newDict.destinazionePlanimetria" pInputText placeholder="Rooms">
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="start center" style="margin-top: 0.5rem;">
                <input fxFlex="47.4" type="text" [(ngModel)]="newDict.macrogruppo" pInputText style="margin-right: 0.5rem;" placeholder="Macro">
                <input fxFlex="47.4" type="text" [(ngModel)]="newDict.coefficienteCalcoloSupTari" pInputText placeholder="Coeff.">
            </div>
        </div>
        <div fxLayout="row wrap" style="margin-top: 1rem;" *ngIf="insertMode">
            <button 
                fxFlex="47" pButton type="button" 
                class="editor-button" style="margin-right: 0.5rem;" 
                [disabled]="!newDict.destinazioneNormalizzata || !newDict.destinazionePlanimetria || !newDict.macrogruppo || !newDict.coefficienteCalcoloSupTari"
                (click)="insertNewDict()">
                Salva
            </button>
            <button fxFlex="47" pButton type="button" class="editor-button" (click)="onCancelInsertMode()">
                Annulla
            </button>
        </div>
    </div>
    <div *ngIf="!dictLoaded" class="spinner-sm" style="margin-top: 2rem;">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</p-panel>
